import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import styles from './styles.module.scss';
import { UnreadLine } from './ui/UnreadLine/UnreadLine';
export const SystemMessage = ({ message, showUnreadLine }) => {
    return (_jsxs("div", Object.assign({ className: styles.systemMessageWrapper }, { children: [showUnreadLine && _jsx(UnreadLine, {}), message && (_jsx("div", Object.assign({ className: styles.systemMessage }, { children: _jsx("div", Object.assign({ className: styles.text }, { children: message })) })))] })));
};
